import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Header } from '@/components/layout/Header';

export const Route = createFileRoute('/cases')({
	component: CasesLayout,
});

function CasesLayout() {
	return (
		<>
			<Header />
			<main>
				<Outlet />
			</main>
		</>
	);
}
